<template>
    <div class="flex items-center space-x-3">
        <div ref="blinker" class="bg-red-600 rounded-full live-blinker"></div>

        <span class="text-white font-mono text-xs uppercase tracking-widest">
            Live
        </span>
    </div>
</template>

<script>
export default {
    mounted() {
        gsap.fromTo(
            this.$refs.blinker,
            { opacity: 0 },
            {
                duration: 0.4,
                opacity: 1,
                repeat: -1,
                yoyo: true,
                ease: 'power1.out',
                scrollTrigger: {
                    trigger: this.$refs.blinker,
                    toggleActions: 'play pause play pause'
                }
            }
        );
    }
};
</script>

<style lang="scss">
.live-blinker {
    width: 10px;
    height: 10px;
}
</style>
